import React from "react";

const TitleModal = ({ title }) => {
  return (
    <p
      dangerouslySetInnerHTML={{
        __html: title
      }}
      style={{ fontSize: "16px", textTransform: "uppercase", fontWeight: "bold" }}
    />
  )
};

export default TitleModal;
